import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {Text} from 'src/design/atoms/Text';

export interface VisibilityImpactTextListProps {
  title: string;
  list: string[];
}

export const VisibilityImpactTextList =
  React.memo<VisibilityImpactTextListProps>(({title, list}) => {
    if (list.length === 0) {
      return null;
    }

    return (
      <>
        <Text pb="xs">{title}</Text>
        {list.slice(0, 3).map((label: string, index: number) => (
          <Text size="xs" key={index} pb="xs">
            {`${index + 1}. ${label}`}
          </Text>
        ))}
        {list.length > 3 ? (
          <Box pb="xs">...and {list.length - 3} more.</Box>
        ) : null}
      </>
    );
  });
